<template>
  <div class="page">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="pageContent.title.rendered"></ContentHeader>
        <div v-if="pageContent._embedded['wp:featuredmedia'] !== undefined" class="featuredImg mb-3">
          <img v-if="pageContent._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
            :src="pageContent._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
            :alt="pageContent._embedded['wp:featuredmedia'][0].alt_text"
            :title="pageContent._embedded['wp:featuredmedia'][0].title.rendered"
          >
        </div>
        <div v-html="pageContent.content.rendered"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    ContentHeader
  },
  data () {
    return {
      pageContent: '',
      contentReady: false,
      contentLoadError: ''
    }
  },
  methods: {
    loadContent: function () {
      WordpressRestAPI.getViewContent('pages?slug=' + this.$route.params.slug + '&_embed')
        .then(response => {
          this.pageContent = response.data[0]
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading content for this page. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  created () {
    document.title = this.$route.params.slug.replace(/-/g, ' ') + ' - ThinkTank'
    this.loadContent()
  },
  watch: {
    '$route' (to, from) {
      document.title = this.$route.params.slug.replace(/-/g, ' ') + ' - ThinkTank'
      this.loadContent()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/Page.vue